import React, {useEffect, useState} from 'react';
import {Card, Row, Col} from "antd";
import { getCustomerAsSelect } from '../../../services/serviceCustomer';
import CustomerReportBaseFilters from './CustomerReportBaseFilters';
import CustomerBaseDisplayContainer from './CustomerBaseDisplayContainer';
import AppointmentList from './AppointmentList';
import BrandList from './BrandList';
import CustomerOfferContainer from './CustomerOfferContainer';

const CustomerReportContainer = () => {
    const [customers, setCustomers] = useState([]);
    const [customer, setCustomer] = useState();
    const [date, setDate] = useState([]);
    const [baseData, setBaseData] = useState({});
    const [showBase, setShowBase] = useState(false);

    useEffect(() => {
        getCustomerAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({label:item.label, value:item.key}))
                    setCustomers(structured);
                }
            })
    }, []);
    
    const updateHandler = ({customerId, startDate, endDate, data}) => {
        setCustomer(customerId);
        const dates = [startDate, endDate]
        setDate([...dates]);
        setBaseData(data);
        setShowBase(true);
    }

    return(
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <Card title={"Müşteri Raporlamaları"}>
                        <CustomerReportBaseFilters 
                            customers={customers}
                            updateHandler={updateHandler}
                        />
                        { showBase ? 
                            <>
                                <CustomerBaseDisplayContainer baseData={baseData}/>
                                <Row>
                                    <Col span={24}>
                                        <CustomerOfferContainer customer={customer} baseDates={date}/>
                                    </Col>
                                </Row>   
                                <Row style={{marginTop: '32px'}} justify='space-between'>
                                    <AppointmentList customer={customer} baseDates={date} />
                                </Row>
                                <Row style={{marginTop: '128px'}} justify={'space-between'}>
                                    <BrandList customer={customer} baseDates={date}/>
                                </Row>  
                            </>
                            : null}
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default CustomerReportContainer;